// Local URLs

// export const API_URL = "http://localhost:8000";
// export const IMAGE_BASE_URL = "http://localhost:8000/"; 

// QA URLs

export const API_URL = "https://pipe.mosol9.in/pied-app";
export const IMAGE_BASE_URL = "https://pipe.mosol9.in/";  

// Live URLs

// export const API_URL = "https://thepiedpiper.app/pied-app";
// export const IMAGE_BASE_URL = "https://thepiedpiper.app/"; 